import { css } from "@emotion/react";
import { media } from "styles/breakpoints";

export const TableLvUpStyle = {
  wrapper: css`
    margin: 0 auto 25px;
    padding: 3px;
    color: #000;
    font-size: 12px;
    border-radius: 10px;
    box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.2);
    background-image: linear-gradient(80deg, #fdffd1 3%, #fefff0 84%, #fff 99%);

    ${media.sm} {
      margin-bottom: 15px;
    }
  `,

  btnLevelUp: css`
    min-width: 80px;
    max-width: 120px;
    line-height: 24px;
    text-align: center;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    border-radius: 12px;
    border: solid 1px #b78510;
    background-image: linear-gradient(to bottom, #fefbb3, #ffcd51);
    cursor: pointer;

    padding: 1px 5px;

    ${media.sm} {
      width: 70px;
      font-size: 10px;
      padding: 0 5px;
    }
  `,

  textStatus: css`
    display: flex;
    align-items: center;
    justify-content: space-between;

    position: relative;
    span {
      font-size: 12px;
      font-weight: 500;
    }
    & ~ span {
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }

    ${media.sm} {
      font-size: 10px;
      span {
        font-size: 10px;
      }
    }
  `,

  textPoint: css`
    span {
      color: red;
    }

    ${media.sm} {
      span {
        font-size: 10px;
      }
    }
  `,

  progressTurnover: (turnover_percentage: number) => css`
    margin: 2px 0;

    height: 8px;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.2);
    border-radius: 4px;
    position: relative;
    &::after {
      content: "";
      position: absolute;
      height: 100%;
      width: ${turnover_percentage}%;
      top: 0;
      left: 0;
      background: red;
      border-radius: 4px;
    }
  `,

  progressDeposit: (turnover_percentage: number) => css`
    margin: 2px 0;

    height: 8px;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.2);
    border-radius: 4px;
    position: relative;
    &::after {
      content: "";
      position: absolute;
      height: 100%;
      width: ${turnover_percentage}%;
      top: 0;
      left: 0;
      background: red;
      border-radius: 4px;
    }
  `,

  progressMoney: css`
    margin: 2px 0;
    height: 8px;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.2);
    border-radius: 4px;
    position: relative;
  `,

  point: css`
    height: 80px;
    padding: 5px 13px 0 11px;
    border: solid 1px #f1da6f;
    p {
      font-size: 14px;
      font-weight: bold;
      margin-bottom: 2px;
    }

    ${media.sm} {
      height: unset;
      padding: 5px 13px 2px 11px;
      p {
        font-size: 12px;
        margin-bottom: 6px;
      }
    }
  `,

  money: css`
    height: 70px;
    border-radius: 0 0 8px 8px;
    padding: 5px 13px 0 11px;
    border: solid 1px #f1da6f;

    p {
      font-size: 14px;
      font-weight: bold;
      margin-bottom: 2px;
    }

    ${media.sm} {
      p {
        font-size: 12px;
        margin-bottom: 6px;
      }
    }
  `,

  levelUpHeader: css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 44px;
    padding: 0 13px 0 11px;
    border-radius: 8px 8px 0 0;
    background-image: linear-gradient(to bottom, #ffe980, #f1da6f);

    p {
      color: #8b5211;
      font-size: 20px;
      font-weight: bold;
    }

    ${media.sm} {
      p {
        font-size: 14px;
      }
    }
  `,

  levelUpContent: css``,
};
